import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState<number>(5);
  const { refreshUser } = useAuth();

  useEffect(() => {
    // Mark payment as completed so UI can unlock next step
    try { localStorage.setItem('userPaymentComplete', 'true'); } catch {}
    refreshUser();
    const timer = setInterval(() => setSeconds((s) => s - 1), 1000);
    const redirect = setTimeout(() => navigate('/user/dashboard'), 5000);
    return () => { clearInterval(timer); clearTimeout(redirect); };
  }, [navigate]);

  useEffect(() => {
    if (seconds < 0) setSeconds(0);
  }, [seconds]);

  return (
    <div className="max-w-xl mx-auto p-6">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 text-center">
        <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Successful</h1>
        <p className="text-gray-600">Thank you! Redirecting to complete your profile in {seconds}s…</p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
